// extracted by mini-css-extract-plugin
export var inner__sp = "Outro-module--inner__sp--2b058";
export var only__pc = "Outro-module--only__pc--741ba";
export var only__sp = "Outro-module--only__sp--af7a0";
export var outro = "Outro-module--outro--edc4a";
export var outro_bg = "Outro-module--outro_bg--83589";
export var outro_button = "Outro-module--outro_button--df31d";
export var outro_imageWrap = "Outro-module--outro_imageWrap--4b824";
export var outro_inner = "Outro-module--outro_inner--526b7";
export var outro_story = "Outro-module--outro_story--bda59";
export var outro_text = "Outro-module--outro_text--7b5ae";